export const TAX_REGISTER_ONLY_PRICING_TIER_ID = "TAX_REG";

export const CALENDAR_LINK = "/dashboard/calendar";
export const POS_LINK = "/dashboard/tax-register/invoice/new";
export const INVOICE_ARCHIVE_LINK = "/dashboard/tax-register/invoice";

export type DashboardSurfaces = {
  showCalendar: boolean;
  showAnalytics: boolean;
  landingLink: string;
};

type DashboardSurfacesInput = {
  pricingTierId: string | null | undefined;
  canViewAnalytics: boolean;
  canOpenPos: boolean;
  canOpenInvoiceArchive: boolean;
};

/**
 * Clients on the tax-register-only package do not pay for the calendar or
 * analytics, so those surfaces are hidden and the dashboard lands on POS.
 */
export function resolveDashboardSurfaces({
  pricingTierId,
  canViewAnalytics,
  canOpenPos,
  canOpenInvoiceArchive,
}: DashboardSurfacesInput): DashboardSurfaces {
  const isTaxRegisterOnly = pricingTierId === TAX_REGISTER_ONLY_PRICING_TIER_ID;

  const taxRegisterLanding = (() => {
    if (canOpenPos) return POS_LINK;
    if (canOpenInvoiceArchive) return INVOICE_ARCHIVE_LINK;
    return null;
  })();

  // Without a routed tax-register page the catch-all would redirect to a path
  // that is not routed and loop, so the calendar stays as the fallback.
  if (!isTaxRegisterOnly || !taxRegisterLanding) {
    return {
      showCalendar: true,
      showAnalytics: canViewAnalytics && !isTaxRegisterOnly,
      landingLink: CALENDAR_LINK,
    };
  }

  return {
    showCalendar: false,
    showAnalytics: false,
    landingLink: taxRegisterLanding,
  };
}
